<h2>{{ transformed?.fieldTitle || 'Praktiline info' }}</h2>
<div [innerHTML]="transformed?.fieldAdditionalBody || transformed?.value || transformed"></div>
